// extracted by mini-css-extract-plugin
export var copyableField = "_ku-4";
export var customerBadge = "_ku-0";
export var customerInfoTitle = "_ku-2";
export var details = "_ku-1";
export var dropdownContainer = "_ku-5";
export var dropdownImage = "_ku-6";
export var editAssigneeForm = "_ku-a";
export var editButton = "_ku-3";
export var email = "_ku-7";
export var hidden = "_ku-d";
export var input = "_ku-8";
export var saveButton = "_ku-b";
export var shopifyIcon = "_ku-c";
export var suggestionBadge = "_ku-e";
export var suggestionText = "_ku-f";
export var username = "_ku-9";